import {
	Button,
	ButtonGroup,
	Grid,
	MenuItem,
	makeStyles,
} from "@material-ui/core";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { ReactHookFormSelect } from "../../../utils";

const useStyles = makeStyles((theme) => ({
	root: {
		marginTop: theme.spacing(2),
		borderTop: "1px solid #E0E0E0",
	},
	assigneeDiv: {
		width: "100%",
		display: "flex",
		paddingTop: "1rem",
		justifyContent: "space-between",
		alignItems: "center",
		// [theme.breakpoints.down("xs")]: {
		//   flexDirection: "column",
		//   justifyContent: "center",
		//   alignItems: "center",
		//   gap: "1rem",
		// },
	},
}));

const StatusIssue = (props) => {
	const classes = useStyles();
	const { stateOption, fetchAPI, issues } = props;
	const { handleSubmit, errors, control, clearErrors } = useForm();
	// eslint-disable-next-line no-unused-vars
	const [onError, setOnError] = useState(true);

	const [assign, setAssign] = useState(1);

	const [addChange, setAddChange] = useState({
		idgroup: "",
		iduser: "",
	});
	const { idgroup, iduser } = addChange;

	const reset = () => {
		setAddChange({
			idgroup: "",
			iduser: "",
		});
		clearErrors();
	};
	const onSubmitIssue = async (data) => {
		const dataFetch = {
			...addChange,
			idlayanan: issues?.idlayanan,
			idticket: issues?.idticket,
		};

		let result = await fetchAPI("editStatusIssue", dataFetch);
		if (result.status === "success") {
			reset();
		}
		return result;
	};

	const handleResetGroup = (type) => {
		if (type === "idgroup") {
			setOnError(false);
			setAssign(1);
			setAddChange({
				...addChange,
				idgroup: "",
			});
		} else if (type === "iduser") {
			setOnError(false);
			setAssign(2);
			setAddChange({
				...addChange,
				iduser: "",
			});
		}
	};

	return (
		<div className={classes.root}>
			<form onSubmit={handleSubmit(onSubmitIssue)}>
				<div className={classes.assigneeDiv}>
					<h3>Assignee</h3>
					<ButtonGroup disableElevation variant="contained" color="primary">
						<Button
							color={assign === 1 ? "secondary" : "default"}
							onClick={() => handleResetGroup("idgroup")}
						>
							Groups
						</Button>
						<Button
							color={assign === 2 ? "secondary" : "default"}
							onClick={() => handleResetGroup("iduser")}
						>
							Users
						</Button>
					</ButtonGroup>
				</div>

				{assign === 1 ? (
					<ReactHookFormSelect
						id="idgroup"
						// register={register}
						name="idgroup"
						label="GROUPS"
						control={control}
						error={errors.idgroup}
						value={idgroup}
						setState={setAddChange}
						state={addChange}
						variant="outlined"
						margin="normal"
						fullWidth
						required
					>
						<MenuItem value="none" disabled selected>
							--Pilih Groups--
						</MenuItem>
						{stateOption.optionGroupIssue &&
							stateOption.optionGroupIssue.map((item, i) => (
								<MenuItem key={i} value={item.id}>
									{item.nama}
								</MenuItem>
							))}
					</ReactHookFormSelect>
				) : assign === 2 ? (
					<ReactHookFormSelect
						id="iduser"
						// register={register}
						name="iduser"
						label="ID USERS"
						control={control}
						error={errors.iduser}
						value={iduser}
						setState={setAddChange}
						state={addChange}
						variant="outlined"
						margin="normal"
						fullWidth
						required
					>
						<MenuItem value="none" disabled selected>
							--Pilih Users--
						</MenuItem>
						{stateOption.optionUserIssue &&
							stateOption.optionUserIssue.map((item, i) => (
								<MenuItem key={i} value={item.id}>
									{item.nama}
								</MenuItem>
							))}
					</ReactHookFormSelect>
				) : (
					""
				)}
				<Grid
					style={{
						display: "flex",
						// marginTop: "0.5rem",
						justifyContent: "end",
					}}
				>
					<Button
						type="submit"
						variant="contained"
						color="primary"
						// disabled={onError}
					>
						Submit &#10148;
					</Button>
				</Grid>
			</form>
		</div>
	);
};

export default StatusIssue;
